// src/components/common/DurationSelect.tsx
import React from 'react';

interface DurationSelectProps {
  hours: string;
  minutes: string;
  onHoursChange: (value: string) => void;
  onMinutesChange: (value: string) => void;
  className?: string;
  disabled?: boolean;
}

const DurationSelect: React.FC<DurationSelectProps> = ({
  hours,
  minutes,
  onHoursChange,
  onMinutesChange,
  className = "",
  disabled = false
}) => {
  // 產生小時選項（0-24）
  const hourOptions = Array.from({ length: 25 }, (_, i) => i.toString());
  
  // 產生分鐘選項（0-55，間隔5分鐘）
  const minuteOptions = Array.from({ length: 12 }, (_, i) => (i * 5).toString().padStart(2, '0'));
  
  return (
    <div className={`flex items-center gap-4 ${className}`}>
      <div className="flex-1">
        <div className="flex items-center">
          <select
            value={hours}
            onChange={(e) => onHoursChange(e.target.value)}
            className={`block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm ${
              disabled ? 'bg-gray-100 text-gray-500 cursor-not-allowed' : ''
            }`}
            disabled={disabled}
            aria-label="Hours"
          >
            <option value="">Hours</option>
            {hourOptions.map(hour => (
              <option key={`hour-${hour}`} value={hour}>{hour}</option>
            ))}
          </select>
          <span className="ml-2 text-sm text-gray-700">hr</span>
        </div>
      </div>
      
      <div className="flex-1">
        <div className="flex items-center">
          <select
            value={minutes}
            onChange={(e) => onMinutesChange(e.target.value)}
            className={`block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm ${
              disabled ? 'bg-gray-100 text-gray-500 cursor-not-allowed' : ''
            }`}
            disabled={disabled}
            aria-label="Minutes"
          >
            <option value="">Minutes</option>
            {minuteOptions.map(minute => (
              <option key={`minute-${minute}`} value={minute}>{minute}</option>
            ))}
          </select>
          <span className="ml-2 text-sm text-gray-700">min</span>
        </div>
      </div>
    </div>
  );
};

export default DurationSelect;